import { apiGet } from './client'

export interface PartResult {
	name: string
	title: string
}

export function searchParts(q: string): Promise<PartResult[]> {
	return apiGet(`/api/parts?q=${encodeURIComponent(q)}`)
}
